import { RouteObject } from 'react-router-dom';
import {
  action as shippingClaimReasonAction,
  loader as shippingClaimReasonLoader,
} from '~/app/features/shipping-claim/new-claim/reason/shippingClaimReason';
import ShippingClaimReasonPage from '~/app/features/shipping-claim/new-claim/reason/ShippingClaimReasonPage';
import { loader as shippingIssueLoader } from '~/app/features/shipping-claim/new-claim/shipping-issue/shippingIssue';
import ShippingIssuePage from '~/app/features/shipping-claim/new-claim/shipping-issue/ShippingIssuePage';
import ReasonSteps from './[:reason]';
import Address from './address';
import Review from './review';

export default {
  path: 'new',
  children: [
    {
      index: true,
      Component: ShippingClaimReasonPage,
      loader: shippingClaimReasonLoader,
      action: shippingClaimReasonAction,
    },
    ReasonSteps,
    Address,
    Review,
    {
      id: 'shippingIssue',
      path: 'shipping-issue',
      Component: ShippingIssuePage,
      loader: shippingIssueLoader,
    },
  ],
} satisfies RouteObject;
